/**
 * Quick Stats Card - Overview statistics for all projects
 */

interface QuickStatsCardProps {
  projects: any[]
}

export function QuickStatsCard({ projects }: QuickStatsCardProps) {
  const totalProjects = projects.length
  const activeProjects = projects.filter((p) => p.isActive).length
  const totalPlatforms = new Set(projects.flatMap((p) => p.platforms)).size
  const totalChannels = new Set(projects.flatMap((p) => p.channels)).size

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
      <div className="bg-secondary rounded-lg p-4">
        <p className="text-sm text-muted-foreground mb-1">Total Projects</p>
        <p className="text-2xl font-bold text-foreground">{totalProjects}</p>
      </div>
      <div className="bg-secondary rounded-lg p-4">
        <p className="text-sm text-muted-foreground mb-1">Active Projects</p>
        <p className="text-2xl font-bold text-green-600">{activeProjects}</p>
      </div>
      <div className="bg-secondary rounded-lg p-4">
        <p className="text-sm text-muted-foreground mb-1">Platforms</p>
        <p className="text-2xl font-bold text-foreground">{totalPlatforms}</p>
      </div>
      <div className="bg-secondary rounded-lg p-4">
        <p className="text-sm text-muted-foreground mb-1">Channels</p>
        <p className="text-2xl font-bold text-foreground">{totalChannels}</p>
      </div>
    </div>
  )
}
